/**
 * What a printed receipt may show.
 *
 * A deferred receipt (إذن تحصيل أجل) authorises a department to treat the
 * patient now and collect later. The patient carries it, and the hospital does
 * not want a figure on it: the price is settled with the contract party or at
 * the desk afterwards, and a number printed on the paper is a number the
 * patient argues with. So a deferred receipt prints no money at all: no amount
 * per line, no total, no paid, no remaining, no payment method. A cash receipt
 * still prints every one of them, zero included.
 *
 * Pure: no React, no DOM.
 */

/** 'cash' or 'deferred'. Old rows carry no type; their status decides. */
export function receiptTypeOf(receipt) {
  if (!receipt) return 'deferred';
  if (receipt.receiptType === 'cash' || receipt.receiptType === 'deferred') return receipt.receiptType;
  return receipt.status === 'collected' ? 'cash' : 'deferred';
}

/** Whether the paper carries amounts: only a cash receipt does. */
export function receiptShowsMoney(receipt) {
  return receiptTypeOf(receipt) === 'cash';
}
